import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import main_reducer from './main_reducer'



export default (history) => combineReducers({
    router: connectRouter(history),
    main:main_reducer
})